"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Header = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _core = require("@material-ui/core");
var _Menu = _interopRequireDefault(require("@material-ui/icons/Menu"));
var _MenuOpen = _interopRequireDefault(require("@material-ui/icons/MenuOpen"));
var _HeaderDesktop = require("./HeaderDesktop");
var _HeaderMobile = require("./HeaderMobile");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 *  Componente web e responsivo do header da Saraiva Educação.
 *
 *  A versão web tem os seguintes componentes:
 *
 *  - Logotipo da Saraiva Educação
 *  - Barra de pesquisa
 *  - Avatar
 *
 *  Sobre o Logotipo: o comportamento comum é que, ao ser clicado, redirecionar para a
 *  página incial (Home) da aplicação, mas esse comportamento deve ser implementado pelas
 *  pessoas desenvolvedoras que estarão consumindo a biblioteca_ através da prop `onClickHome`.
 *  Essa prop será aplicada tanto na versão web quanto na responsiva.
 *
 *  Sobre a Barra de pesquisa: Tem o comportamento ligeiramente diferente da versão responsiva.
 *  Para explicar melhor, podemos pensar nos seguintes estados:
 *    1. Inicial -> Logo após o header ser renderizado ou quando a pessoa usuária clica pela primeira vez
 *      na barra de pesquisa ou quando não existe caractere no campo de busca. Deve aparecer com um
 *      ícone de lupa no canto esquerdo (não é botão), sem o botão de limpar pesquisa (o "X") no canto direito
 *      e a mensagem de placeholder.
 *    2. Digitando/Pesquisado -> Quando existe algum caractere na barra de pesquisa. O ícone do canto esquerdo
 *      muda para um botão de voltar (com a seta <--) e o botão de limpar pesquisa (o "X") aparece.
 *
 *  Sobre o Avatar: Tanto na versão web quanto na mobile, ao clicar no avatar é exibida uma gaveta
 *  (também referida como Menu) com, pelo menos, as informações iniciais (nome e email)
 *  da pessoa usuária.
 *
 *  ----------------
 *
 *  A versão mobile possui os mesmos componentes para o header superior, mas eles são exibidos
 *  em momentos diferentes. Existe também a barra inferior (bottom navigation) com os botões
 *  "Início" e "Busca". Podemos dizer que o header superior responsivo possui quatro estados:
 *
 *    1. Inicial: mostra o header "padrão" apenas com o logotipo e o avatar. É exibido quando
 *    a página é carregada ou quando a pessoa usuária clica no botão "Início" da bottom navigation
 *    2. Buscando: quando a pessoa clica em "Busca", o header anterior é completamente substituído pela
 *    barra de pesquisa. O estado inicial dessa barra é com o botão de voltar (<--) e sem o botão de
 *    limpar campo ("X"), exibindo apenas a mensagem de placeholder.
 *    3. Digitando: quando existe algum caractere na barra de pesquisa. O ícone do canto esquerdo <-- e
 *    o botão de limpar pesquisa (o "X") aparecem. SEMPRE que a pessoa estiver fazendo uma busca,
 *    será exibido um fundo cinza com transparência do componente do Modal, para que o foco esteja na pesquisa.
 *    Nesse estado, quando a pessoa clicar no botão voltar (<--), esse fundo transparente desaparecerá
 *    e o header será substituído para o estado que estava anteriormente (Inicial ou Final).
 *    4. Final: quando a pessoa teclar "enter" para realizar a busca, o cabeçalho de busca aparecerá
 *    sem o fundo cinza, mas com a barra preenchida com o termo pesquisado. Aparece o ícone da lupa.
 *
 */

const Header = props => {
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_core.Hidden, {
    smUp: true
  }, /*#__PURE__*/_react.default.createElement(_HeaderMobile.HeaderMobile, props)), /*#__PURE__*/_react.default.createElement(_core.Hidden, {
    xsDown: true
  }, /*#__PURE__*/_react.default.createElement(_HeaderDesktop.HeaderDesktop, props)));
};
exports.Header = Header;
Header.propTypes = {
  /**
   * Nome do usuário exibido ao clicar no menu
   */
  username: _propTypes.default.string.isRequired,
  /**
   * Email do usuário exibido ao clicar no menu
   */
  email: _propTypes.default.string.isRequired,
  /**
   * Função requerida para quando o usuário clicar no logotipo presente no header.
   */
  onClickHome: _propTypes.default.func.isRequired,
  /**
   * Mensagem que aparecerá como placeholder da barra de pesquisa
   */
  searchPlaceHolder: _propTypes.default.string,
  /**
   *  Classes para serem aplicadas na `div` que engloba a barra de pesquisa
   */
  inputWrapperClasses: _propTypes.default.func,
  /**
   * Função requerida para quando a pessoa realizar a pesquisa (apertar o Enter).
   * Receberá como parâmetro o termo que está na barra de pesquisa
   */
  searchCallback: _propTypes.default.func.isRequired,
  /**
   * Lista de objetos que serão concatenados ao menu (aberto ao clicar no avatar).
   */
  menuItems: _propTypes.default.arrayOf(_propTypes.default.shape({
    nodeIcon: _propTypes.default.node,
    label: _propTypes.default.string,
    onClick: _propTypes.default.func
  }).isRequired).isRequired,
  /**
   * Lista de objetos que serão concatenados na drawer (aberto ao clicar no menu hamburguer).
   */
  drawerItems: _propTypes.default.arrayOf(_propTypes.default.shape({
    nodeIcon: _propTypes.default.node,
    label: _propTypes.default.string,
    onClick: _propTypes.default.func
  }).isRequired),
  /**
   * Esconde o menu que é aberto ao clicar no avatar do usuário
   */
  hiddenMenu: _propTypes.default.bool,
  /**
   * Logo que aparecerá no topo da página caso seja passado um arquivo de imagem.
   */
  logo: _propTypes.default.element,
  /**
   * Logo que aparecerá no topo da página caso seja passado uma tag de imagem.
   */
  logoImg: _propTypes.default.node,
  /**
   * Se `TRUE`, habilita o menu sanduiche na versao mobile
   */
  navigateMenu: _propTypes.default.bool,
  /**
   * Se 'TRUE' a search bar fica centralizada ao centro de forma absoluta
   */
  centralized: _propTypes.default.bool,
  /**
   * Se 'TRUE' habilita o menu sanduiche no header
   */
  sandwich: _propTypes.default.bool,
  /**
   * Ícone do menu sanduiche enquanto está fechado
   */
  sandwichClosedIcon: _propTypes.default.node,
  /**
   * Ícone do menu sanduiche enquanto está aberto
   */
  sandwichOpenedIcon: _propTypes.default.node,
  /**
   * Se 'TRUE', a bottom navigation apresenta o botao de categorias
   */
  hasCategories: _propTypes.default.bool,
  /**
   * Função requerida para quando o usuário clicar no botao de categorias da bottom navigation
   */
  onClickCategories: _propTypes.default.func.isRequired,
  /**
   * Se 'TRUE', o estado do menu sandwich é aberto
   */
  isOpenSandwich: _propTypes.default.bool,
  /**
   * Funcao que manipula o estado do menu sanduiche
   */
  setIsOpenSandwich: _propTypes.default.func,
  /**
   * Se True, retorna a altura dos menuItems como 'auto'
   */

  isFullHeight: _propTypes.default.bool
};
Header.defaultProps = {
  searchPlaceHolder: 'Buscar...',
  inputWrapperClasses: null,
  hiddenMenu: false,
  logo: null,
  navigateMenu: false,
  drawerItems: null,
  centralized: false,
  logoImg: null,
  sandwich: false,
  sandwichClosedIcon: /*#__PURE__*/_react.default.createElement(_Menu.default, null),
  sandwichOpenedIcon: /*#__PURE__*/_react.default.createElement(_MenuOpen.default, null),
  hasCategories: false,
  isOpenSandwich: false,
  setIsOpenSandwich: null,
  isFullHeight: false
};
var _default = exports.default = Header;